import { Image, StyleSheet, Text, View } from 'react-native'
import React, { useEffect } from 'react'
import { ThemedText } from '@app/theme/Components';
import { Theme, ThemedView } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { useTheme } from '@shopify/restyle';
import Svg from '@app/sharedComponents/SvgImage/Svg';

const TataSignSuccessModal = ({ onSuccess }: { onSuccess: () => void }) => {

  const { colors } = useTheme<Theme>();


  useEffect(() => {

    let timeout: string | number | NodeJS.Timeout | undefined;

    if (onSuccess) {
      timeout = setTimeout(() => {
        onSuccess();
      }, 3000);
    }


    return () => clearTimeout(timeout);
  }, [onSuccess])


  return (
    <ThemedView padding='lg' justifyContent='center' alignItems='center'>
      <Svg
        url='https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusSuccess_1.svg'
        height={48}
        width={48}
      />
      <ThemedText mt='lg' variant='h5s'>Agreement signed successfully!</ThemedText>
      <ThemedText textAlign='center' mt='sm' variant='b3r' color='text-secondary'>
        You will be redirected to next step in few seconds
      </ThemedText>
      <ThemedView alignSelf='stretch' marginVertical='md'>
        <Button
          label="Proceed to next step"
          type="SOLID"
          size='MD'
          handlePress={onSuccess}
          bg={colors['bg-action-primary']}
          textColor={colors['text-primary']}
        />
      </ThemedView>
    </ThemedView>
  )
}

export default TataSignSuccessModal

const styles = StyleSheet.create({})